import { Button, makeStyles, ProgressBar, Text, tokens } from '@fluentui/react-components'
import { DismissRegular } from '@fluentui/react-icons'

import { ErrorMessageBar } from '../../../../components/ErrorMessageBar'
import type { WorkspaceUploadProgress } from '../../../../shared/models/WorkspaceItem'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    // maxWidth: '640px',
    overflowWrap: 'anywhere',
  },
  progressbar: {
    width: '100%',
  },
})

interface WorkspaceUploadStatusProps {
  progress: WorkspaceUploadProgress | null
  policyError: boolean
  onRetryPolicy: () => void
  onDismiss: () => void
}

export default function WorkspaceUploadStatus({
  progress,
  policyError,
  onRetryPolicy,
  onDismiss,
}: WorkspaceUploadStatusProps) {
  const styles = useStyles()
  const progressValue = progress?.totalBytes
    ? progress.uploadedBytes / progress.totalBytes
    : progress?.status === 'complete'
      ? 1
      : 0

  return (
    <>
      {policyError && (
        <ErrorMessageBar title="Failed to load upload rules" onRetry={onRetryPolicy} />
      )}
      {progress && (
        <div className={styles.root}>
          <Text role={progress.status === 'error' ? 'alert' : 'status'}>
            {progress.status === 'error'
              ? `Upload failed for ${progress.fileName}: ${progress.error}`
              : progress.status === 'complete'
                ? `Uploaded ${progress.totalFiles} ${progress.totalFiles === 1 ? 'file' : 'files'}`
                : `Uploading ${progress.fileName} (${progress.fileIndex + 1} of ${progress.totalFiles})`}
          </Text>
          <ProgressBar
          className={styles.progressbar}
            value={progressValue}
            max={1}
            thickness="medium"
            color={progress.status === 'error' ? 'error' : 'brand'}
            aria-label="File upload progress"
          />
          {/* {progress.status !== 'uploading' && (
            <Button
              appearance="subtle"
              icon={<DismissRegular />}
              aria-label="Dismiss upload status"
              title="Dismiss upload status"
              onClick={onDismiss}
            />
          )} */}
        </div>
      )}
    </>
  )
}
